var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1566_4148)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.6846,
    cy: 14.999,
    r: 14.7998,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6846,
    cy: 12.3115,
    r: 4.78809,
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1478 24.3331C20.7553 17.2488 11.0262 17.6912 3.7002 23.6622C9.48773 31.5428 19.8177 33.0035 27.1478 24.3331Z",
    fill: "#DADADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1566_4148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30,
    fill: "white",
    transform: "translate(0.18457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImage);
export default __webpack_public_path__ + "static/media/userImage.51ae5e6227b9d379cfef4cf123b83024.svg";
export { ForwardRef as ReactComponent };